<template>
  <div class="flex flex-row justify-center w-full">
    <div class="form-page form-3">
        <div id="root3">
            <sc-text v-if="fields.holdingMessage"
                     tag="p"
                     class="text-lg p-10 text-center"
                     :field="fields.holdingMessage" />
        </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { Text } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'EntryForm3',
  components: {
    ScText: Text,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    onMounted(() => {
      if (!props.fields?.holdingMessage?.value?.trim()) {
        const rewardsWidget = document.createElement('script');
        rewardsWidget.setAttribute(
          'src',
          'https://assets-emea.rewards.heineken.com/libs/widget/3.4.3/RewardsWidget.3.4.3.js'
        );

        // Wait for the script to load before initializing the widget
        rewardsWidget.onload = () => {
          // eslint-disable-next-line no-undef
          new Rewards.RewardsWidget({
            campaignId: 'd80ec753-982f-4d39-badb-1d525df46e7e',
            previewToken: '3355bf44013536fc8209f77e68801d47cbaa8d31',
            apiUrl: 'https://api-emea.rewards.heineken.com/rewards-hint',
            apiKey: '536e5109ad1b4d939f3ae23354da634b',
            selector: '#root3',
          });
        };

        document.head.appendChild(rewardsWidget);
      }
    });
  },
};
</script>
<style>
@import url('https://assets-emea.rewards.heineken.com/cms/brandstyles/Fosters/styles.css');
@import url('https://assets-emea.rewards.heineken.com/cms/campaignstyles/d80ec753-982f-4d39-badb-1d525df46e7e/styles.css');

</style>
